import cx from 'classnames'
import { ReactNode } from 'react'
import {
  SanityButtonStyle,
  SanityFontCase,
} from '@data/sanity/queries/types/link'
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  getButtonColor,
  getButtonIconAlignment,
  getButtonSize,
  getButtonVariant,
} from '@components/buttons/button'
import ButtonLink from '@components/buttons/button-link'
import LinkFrame from './frame'

interface ExternalLinkProps {
  url: string
  id?: string
  tabIndex?: number
  'aria-label'?: string
  buttonVariant?: ButtonVariant
  buttonSize?: ButtonSize
  buttonColor?: ButtonColor
  buttonStyles?: SanityButtonStyle
  isButton?: boolean
  fontCase?: SanityFontCase
  className?: string
  children?: ReactNode
}

const ExternalLink = ({
  url,
  id,
  tabIndex,
  'aria-label': ariaLabel,
  buttonVariant,
  buttonSize,
  buttonColor,
  buttonStyles,
  isButton,
  fontCase,
  className,
  children,
}: ExternalLinkProps) => {
  const externalLinkButton = (
    <ButtonLink
      id={id}
      href={url}
      target="_blank"
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      rel="noopener noreferrer"
      variant={buttonVariant ?? getButtonVariant(buttonStyles?.variant)}
      size={buttonSize ?? getButtonSize(buttonStyles?.size)}
      color={buttonColor ?? getButtonColor(buttonStyles?.color)}
      icon={buttonStyles?.icon}
      iconAlignment={getButtonIconAlignment(buttonStyles?.iconAlignment)}
      className={cx(
        { btn: isButton, 'w-full': buttonStyles?.isFullWidth },
        fontCase ?? '',
        className,
      )}
    >
      {children}
    </ButtonLink>
  )

  return buttonStyles?.frame ? (
    <LinkFrame buttonStyles={buttonStyles}>{externalLinkButton}</LinkFrame>
  ) : (
    externalLinkButton
  )
}

export default ExternalLink
